module.exports = __webpack_public_path__ + "fonts/Akkurat-Bold.cc4c7e3a.ttf";